import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Empty from 'components/common/Empty';
import Table from 'components/common/table';
import { useHistory } from 'react-router-dom';
import { TablePaginationProps } from './config/guestPayers';
import { getLocationFromGuestLoan } from '../paths';

const useStyles = makeStyles(() => ({
  empty: {
    position: 'relative',
    minHeight: 290,
  },
}));

const GuestPayers = ({ data, isLoading, columnMeta }) => {
  const classes = useStyles();
  const history = useHistory();
  const handleGuestRowClick = useCallback(
    (payer) => {
      if (payer && payer.number && payer.type) {
        localStorage.setItem('guestLoanNumber', payer.number);
        localStorage.setItem('guestLoanType', payer.type);
        const location = getLocationFromGuestLoan(payer);
        history.push(location);
      }
    },
    [history]
  );

  const guestLoans = Array.isArray(data) ? data : [];

  return (
    <div>
      {isLoading ? (
        <div>Loading...</div>
      ) : guestLoans.length === 0 ? (
        <div className={classes.empty} data-testid="guest-no-results">
          <Empty
            subheading="Try modifying your search criteria."
            title="No Guest Payers Found"
          />
        </div>
      ) : (
        <Table
          columnMeta={columnMeta}
          data={guestLoans}
          isLoading={false}
          onChange={undefined}
          onRowClick={handleGuestRowClick}
          TablePaginationProps={TablePaginationProps}
        />
      )}
    </div>
  );
};

GuestPayers.propTypes = {
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  columnMeta: PropTypes.array.isRequired,
};

GuestPayers.defaultProps = {
  isLoading: false,
};

export default GuestPayers;
